import { useState } from 'react';
import { removeDangerousSpecialCharacters } from 'modules/utils/removeDangerousSpecialCharacters';

function useContactUsTextArea() {
  const [questionText, setQuestionText] = useState<string>('');
  const handleQuestionAdd = (question: string) => {
    const questionWithDangerousCharactersRemoved = removeDangerousSpecialCharacters(question);
    setQuestionText(questionWithDangerousCharactersRemoved);
  };
  return { questionText, onQuestionTextChange: handleQuestionAdd };
}

export default useContactUsTextArea;
